/* oxlint-disable no-top/no-top-level-side-effects -- Declarative Drizzle schema, like the actor _tables definitions. */
import { crudTable, date, index } from "@-/dev.improve.haniverse.lib.database.table";

/** One uninterrupted foreground study interval, checkpointed while studying. */
export const studySessionTable = crudTable(
  "study_session",
  {
    endedAt: date("ended_at").notNull(),
    startedAt: date("started_at").notNull(),
  },
  (table) => [index("study_session_started_at_idx").on(table.startedAt)],
);
/* oxlint-enable no-top/no-top-level-side-effects */
